"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var SelectField_1 = require("./SelectField");
var i18n_1 = require("@wordpress/i18n");
function is_locale(locale_string) {
    var _a;
    var body_locale_tag = (_a = document.querySelector('html').getAttribute('lang')) !== null && _a !== void 0 ? _a : '';
    return body_locale_tag == locale_string;
}
function generateYears(yearsToAdd) {
    var startYear = new Date().getFullYear(), years = [];
    for (var i = 0; i < yearsToAdd; i++) {
        var years_name = String(startYear + i);
        if (is_locale('ja')) {
            years_name = years_name + '年';
        }
        years.push({
            'id': startYear + i,
            'name': years_name,
        });
    }
    return years;
}
function generateDays() {
    var days = [];
    for (var i = 1; i <= 31; i++) {
        var days_name = String(i);
        if (is_locale('ja')) {
            days_name = days_name + '日';
        }
        days.push({
            'id': i,
            'name': days_name,
        });
    }
    return days;
}
function ProjectFlexiDates(_a) {
    var durations = _a.durations, flexiDate = _a.flexiDate, durationDays = _a.durationDays, setDurationDays = _a.setDurationDays, setFlexiDate = _a.setFlexiDate;
    var handleDurationChange = function (event) {
        var value = event.target.value;
        setDurationDays(value);
    };
    var monthOptions = [
        { id: '1', name: (0, i18n_1.__)("January", 'projects-abroad') },
        { id: '2', name: (0, i18n_1.__)("February", 'projects-abroad') },
        { id: '3', name: (0, i18n_1.__)("March", 'projects-abroad') },
        { id: '4', name: (0, i18n_1.__)("April", 'projects-abroad') },
        { id: '5', name: (0, i18n_1.__)("May", 'projects-abroad') },
        { id: '6', name: (0, i18n_1.__)("June", 'projects-abroad') },
        { id: '7', name: (0, i18n_1.__)("July", 'projects-abroad') },
        { id: '8', name: (0, i18n_1.__)("August", 'projects-abroad') },
        { id: '9', name: (0, i18n_1.__)("September", 'projects-abroad') },
        { id: '10', name: (0, i18n_1.__)("October", 'projects-abroad') },
        { id: '11', name: (0, i18n_1.__)("November", 'projects-abroad') },
        { id: '12', name: (0, i18n_1.__)("December", 'projects-abroad') },
    ];
    var dayOptions = generateDays();
    var yearOptions = generateYears(10);
    var day = flexiDate.day, month = flexiDate.month, year = flexiDate.year;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("fieldset", { children: [(0, jsx_runtime_1.jsx)("legend", __assign({ className: "appform-field__label" }, { children: (0, i18n_1.__)("Start date", "projects-abroad") })), (0, jsx_runtime_1.jsx)(SelectField_1.default, { name: "start_day", label: "", options: dayOptions, required: true, defaultOptionLabel: (0, i18n_1.__)('Day', 'projects-abroad'), value: day, onChange: function (event) { return setFlexiDate(__assign(__assign({}, flexiDate), { day: event.target.value })); }, ariaLabel: (0, i18n_1.__)('Day', 'projects-abroad') }), (0, jsx_runtime_1.jsx)(SelectField_1.default, { name: "start_month", label: "", options: monthOptions, required: true, defaultOptionLabel: (0, i18n_1.__)('Month', 'projects-abroad'), value: month, onChange: function (event) { return setFlexiDate(__assign(__assign({}, flexiDate), { month: event.target.value })); }, ariaLabel: (0, i18n_1.__)('Month', 'projects-abroad') }), (0, jsx_runtime_1.jsx)(SelectField_1.default, { name: "start_year", label: "", options: yearOptions, required: true, defaultOptionLabel: (0, i18n_1.__)('Year', 'projects-abroad'), value: year, onChange: function (event) { return setFlexiDate(__assign(__assign({}, flexiDate), { year: event.target.value })); }, ariaLabel: (0, i18n_1.__)('Year', 'projects-abroad') }), (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "start_date", value: "".concat(year, "-").concat(month, "-").concat(day) })] }), durations.length > 0 && ((0, jsx_runtime_1.jsx)(SelectField_1.default, { name: "duration_days", label: (0, i18n_1.__)("Duration", "projects-abroad"), options: durations.map(function (o) { return ({
                    id: o.durationDays,
                    name: o.name,
                }); }), defaultOptionLabel: (0, i18n_1.__)("Select a duration", "projects-abroad"), required: true, onChange: handleDurationChange, value: durationDays }))] }));
}
exports.default = ProjectFlexiDates;
